import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { AppProfileService } from '../services/profile.service';

/**
 * Carrier-only pages (#199: „Registrierungen", the cross-customer view of every registration).
 * Anyone else is sent to their own user list rather than shown a page they have no data for.
 */
export const carrierGuard: CanActivateFn = () => {
  const router = inject(Router);
  return inject(AppProfileService).currentProfile$.pipe(
    take(1),
    map((profile) => (profile?.isCarrier ? true : router.createUrlTree(['/shop-user-list']))),
  );
};
